import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { FaEye, FaEyeSlash } from "react-icons/fa";
import { ApiUrl } from "../../../ApiUrl";
import "./StudentChangePassword.css";

const StudentChangePassword = () => {
  const navigate = useNavigate();
  const [username] = useState(sessionStorage.getItem("username") || "");
  const [oldPassword, setOldPassword] = useState("");
  const [newPassword, setNewPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [showOldPassword, setShowOldPassword] = useState(false);
  const [showNewPassword, setShowNewPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);
  const [saving, setSaving] = useState(false);

  const handleSave = async () => {
    const studentId = sessionStorage.getItem("userId");

    if (!studentId) {
      alert("Student session details are missing. Please log in again.");
      return;
    }

    if (!oldPassword || !newPassword || !confirmPassword) {
      alert("Please fill in all fields.");
      return;
    }

    if (newPassword !== confirmPassword) {
      alert("Passwords do not match.");
      return;
    }

    if (oldPassword === newPassword) {
      alert("Old password and new password may not be the same.");
      return;
    }

    try {
      setSaving(true);

      const response = await fetch(
        `${ApiUrl.apiurl}STUDENT_PROFILE/ChangeStudentPassword/`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            student_id: studentId,
            old_password: oldPassword,
            new_password: newPassword,
            confirm_password: confirmPassword,
          }),
        }
      );

      const contentType = response.headers.get("content-type") || "";
      const payload = contentType.includes("application/json")
        ? await response.json()
        : null;

      if (!response.ok) {
        throw new Error(payload?.message || "Unable to change password.");
      }

      alert(payload?.message || "Password changed successfully!");
      setOldPassword("");
      setNewPassword("");
      setConfirmPassword("");
    } catch (error) {
      console.error("Error changing student password:", error);
      alert(error.message || "Unable to change password.");
    } finally {
      setSaving(false);
    }
  };

  const handleClear = () => {
    setOldPassword("");
    setNewPassword("");
    setConfirmPassword("");
  };

  const handleClose = () => {
    navigate("/student/dashboards");
  };

  return (
    <div className="container-fluid student-change-password-page">
      <div className="row">
        <div className="col-12">
          <div className="student-change-password-shell">
            <div className="student-change-password-header">
              <h2 className="student-change-password-title">CHANGE PASSWORD</h2>
            </div>

            <div className="student-change-password-toolbar">
              <div className="student-change-password-actions">
                <button
                  type="button"
                  className="btn btn-primary student-change-password-btn"
                  onClick={handleSave}
                  disabled={saving}
                >
                  {saving ? "Saving..." : "Save"}
                </button>
                <button
                  type="button"
                  className="btn btn-secondary student-change-password-btn"
                  onClick={handleClear}
                  disabled={saving}
                >
                  Clear
                </button>
                  <button
                    type="button"
                    className="btn btn-danger student-change-password-btn"
                    onClick={handleClose}
                    disabled={saving}
                  >
                    Close
                  </button>
              </div>
            </div>

            <div className="student-change-password-card">
              <div className="student-change-password-form-wrap">
                <div className="student-change-password-form-grid">
                  <label className="student-change-password-label">Username</label>
                  <input
                    type="text"
                    className="form-control student-change-password-readonly"
                    value={username}
                    readOnly
                    disabled
                  />

                  <label className="student-change-password-label">
                    Old Password<span className="text-danger">*</span>
                  </label>
                  <div className="input-group">
                    <input
                      type={showOldPassword ? "text" : "password"}
                      className="form-control"
                      value={oldPassword}
                      onChange={(e) => setOldPassword(e.target.value)}
                      placeholder="Enter current password"
                    />
                    <span
                      className="input-group-text"
                      onClick={() => setShowOldPassword(!showOldPassword)}
                      style={{ cursor: "pointer", backgroundColor: "#ffffff" }}
                    >
                      {showOldPassword ? <FaEyeSlash /> : <FaEye />}
                    </span>
                  </div>

                  <label className="student-change-password-label">
                    New Password<span className="text-danger">*</span>
                  </label>
                  <div className="input-group">
                    <input
                      type={showNewPassword ? "text" : "password"}
                      className="form-control"
                      value={newPassword}
                      onChange={(e) => setNewPassword(e.target.value)}
                      placeholder="Enter new password"
                    />
                    <span
                      className="input-group-text"
                      onClick={() => setShowNewPassword(!showNewPassword)}
                      style={{ cursor: "pointer", backgroundColor: "#ffffff" }}
                    >
                      {showNewPassword ? <FaEyeSlash /> : <FaEye />}
                    </span>
                  </div>

                  <label className="student-change-password-label">
                    Confirm Password<span className="text-danger">*</span>
                  </label>
                  <div className="input-group">
                    <input
                      type={showConfirmPassword ? "text" : "password"}
                      className="form-control"
                      value={confirmPassword}
                      onChange={(e) => setConfirmPassword(e.target.value)}
                      placeholder="Confirm new password"
                    />
                    <span
                      className="input-group-text"
                      onClick={() => setShowConfirmPassword(!showConfirmPassword)}
                      style={{ cursor: "pointer", backgroundColor: "#ffffff" }}
                    >
                      {showConfirmPassword ? <FaEyeSlash /> : <FaEye />}
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default StudentChangePassword;
